import { ActionContext, ActionTree } from "vuex";
import { GetterTree } from "vuex";
import { CarSelectQuickInfoCustomerData } from "@/model/CarSelectionQuickInfoCustomer";

const initialState: CarSelectQuickInfoCustomerData = {
    kojinNmKjMei: "",
    kojinNmKjSei: "",
    kojinNmKnMei: "",
    kojinNmKnSei: "",
    gender: null,
    birthday: null,
    address1: null,
    address2: null,
    prefCd: "",
    prefNm: "",
    zipcode: "",
    keitai: "",
    mailAddress: "",
    vehicleNm: ""
};

const actions: ActionTree<CarSelectQuickInfoCustomerData, any> = {
  setState(
    { commit }: ActionContext<CarSelectQuickInfoCustomerData, any>,
    payload: CarSelectQuickInfoCustomerData
  ): void {
    commit("setState", payload);
  },
  clearState({ commit }: ActionContext<CarSelectQuickInfoCustomerData, any>): void {
    commit("clearState");
  }
};

const mutations = {
  setState(state: CarSelectQuickInfoCustomerData, payload: CarSelectQuickInfoCustomerData) {
    Object.assign(state, payload);
  },
  clearState(state: CarSelectQuickInfoCustomerData) {
    Object.assign(state, { ...initialState });
  }
};

const getters: GetterTree<CarSelectQuickInfoCustomerData, any> = {
  currentState(state: CarSelectQuickInfoCustomerData): any {
    return state;
  },
};

const namespaced: boolean = true;
export default {
  namespaced,
  state: { ...initialState },
  getters,
  actions,
  mutations
};
